const LOOPS_API_KEY = '9ea1e6048a239324583e96152352332c';
const LOOPS_API_ENDPOINT = 'https://app.loops.so/api/v1/contacts/create';

export async function subscribeToNewsletter(email: string) {
  try {
    const response = await fetch(LOOPS_API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${LOOPS_API_KEY}`
      },
      body: JSON.stringify({ email })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Newsletter API error:', {
        status: response.status,
        statusText: response.statusText,
        body: errorText
      });
      throw new Error(`Newsletter subscription failed: ${response.status} ${response.statusText}`);
    }

    return true;
  } catch (error) {
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
      console.error('Newsletter subscription network error: Could not reach the Loops API. This might be due to network connectivity issues or CORS configuration.');
    } else {
      console.error('Newsletter subscription error:', error);
    }
    throw error;
  }
}